// trigger back in stock modal via button click
export default function handleNotifyMe() {
  $(document).on("click", `.js-notify-me`, function (e) {
    const quickshopSelector = $(this).parent().hasClass("js-is-quickshop")
      ? "#quickshop.is-open"
      : "";

    let variantClass = $(this)
      .prop("class")
      .split(" ")
      .find((_class) => _class.includes("js-variant-quantity"));

    variantClass = variantClass ? variantClass.split("-") : variantClass;

    $(".js-quickshop-notify-target").addClass("hidden");
    e.preventDefault();

    const $modalNotify = $(".js-modal-notify");

    const notifyProductId = variantClass
      ? variantClass[variantClass.length - 1]
      : $(`${quickshopSelector} .js-main-select option:selected`).val();

    if (quickshopSelector.length > 0) {
      $(".notify-product").addClass("hidden");
      $.get(`/admin/api/2021-04/variants/${notifyProductId}.json`).done(
        ({ variant }) => {
          $(".js-quickshop-notify-target").attr(
            "data-notify-product-id",
            variant.id
          );
          $.get(`/admin/api/2021-04/products/${variant.product_id}.json`).done(
            ({ product }) => {
              const variantImage =
                product.images.length > 0 &&
                product.images.filter(
                  (image) => image.alt && image.alt.includes(variant.option1)
                )[0];

              const firstAvailableImage = variantImage || product.images[0];
              const { option1, option2, option3 } = variant;
              $(".js-quickshop-notify-target .notify-product__image img")
                .prop("src", firstAvailableImage.src)
                .prop("data-custom-src", firstAvailableImage.src)
                .prop("alt", firstAvailableImage.alt);
              $(".js-quickshop-notify-target .notify-product__content h6").text(
                product.title
              );
              $(".js-quickshop-notify-target .notify-product__variants").text(
                `${option1}${option2 ? " /" + option2 : ""}${
                  option3 ? " /" + option3 : ""
                }`
              );
              $(".js-quickshop-notify-target .notify-product .price__amount")
                .html(`
                <span class="money">${variant.price}</span>
              `);

              $(".js-quickshop-notify-target").removeClass("hidden");
            }
          );
        }
      );
    }
    // get selected variant image src
    const notifyProductImageSrc = $(
      `[data-notify-product-id="${notifyProductId}"]`
    )
      .find("img")
      .data("custom-src");

    $("[data-notify-product-id]").addClass("hidden");
    $(`[data-notify-product-id="${notifyProductId}"]`).removeClass("hidden");
    $(`[data-notify-product-id="${notifyProductId}"] img`).prop(
      "src",
      notifyProductImageSrc
    );

    $modalNotify.addClass("expanded");

    $modalNotify.find("form").removeClass("error submitted");

    $("body").addClass("no-scroll");
  });

  // klavio Back in stock
  $(".js-notify form").on("submit", function (e) {
    const quickshopSelector =
      $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";
    e.preventDefault();
    const $this = $(this);
    const $checkbox = $this.find('input[name="terms"]');

    $checkbox.removeClass("checkbox-error");

    if ($checkbox.get(0).checked === false) {
      $checkbox.addClass("checkbox-error");

      return;
    }

    const $error = $this.find(".form__error");
    const action = $this.attr("action");
    // Find Current Variant Id
    const variantId = $(
      `${quickshopSelector} .js-main-select option:selected`
    ).val();
    $this.find('input[name="variant"]').val(variantId);

    $.ajax({
      url: action,
      method: "POST",
      data: $this.serialize(),
    })
      .done(function (result) {
        if (result.success) {
          // Show Success Message
          messageStatus($this, "success");
        }
      })
      .fail(function (result) {
        // show Error Message
        const errorText = result.responseJSON.message.split("* ");

        $error.text(errorText[errorText.length - 1]);

        messageStatus($this, "error");
      });
  });
}

handleNotifyMe();

function messageStatus($this, message) {
  switch (message) {
    case "error":
      $this.removeClass("submitted");
      $this.addClass("error");
      break;
    default:
      // success
      $this.addClass("submitted");
      $this.removeClass("error");
      break;
  }
}
